<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { BTN, BTN_SECONDARY, SMALL } from '../ui';

// "Tem certeza?" ao pular o WhatsApp: só libera o pular depois do "Entendi".
const props = defineProps({
  realEstate: { type: Boolean, default: false },
});
const emit = defineEmits(['connect', 'skip']);

const { t } = useI18n();
const understood = ref(false);

const losses = computed(() => [
  'AI_REPLY',
  ...(props.realEstate ? ['PROPERTY_CARDS', 'VISITS'] : ['FOLLOW_UP']),
]);
</script>

<template>
  <div class="fixed inset-0 z-50 flex md:items-center md:justify-center max-md:items-end">
    <div class="absolute inset-0 bg-[rgba(16,24,40,.45)] dark:bg-black/65" />
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="pular-titulo"
      class="relative bg-n-card p-8 md:w-[32.5rem] md:max-w-[calc(100vw-2rem)] md:rounded-[1.75rem] max-md:w-full max-md:rounded-t-3xl max-md:px-5 max-md:pt-6 max-md:pb-7 animate-[fade-in-up_200ms_cubic-bezier(.4,0,.2,1)] motion-reduce:animate-none"
      data-testid="confirmar-pular"
    >
      <span class="size-12 rounded-xl grid place-items-center bg-n-amber-3 text-n-amber-11 mb-[1.125rem]">
        <Icon icon="i-ph-warning-duotone" class="size-[1.625rem]" />
      </span>
      <h2 id="pular-titulo" class="text-2xl leading-tight tracking-[-0.025em] font-medium">
        {{ t('ONBOARDING_VISOR.SKIP.TITLE') }}
        <br />
        <span class="text-n-slate-10">{{ t('ONBOARDING_VISOR.SKIP.SUBTITLE') }}</span>
      </h2>
      <p class="text-n-slate-11 mt-2.5">
        {{ realEstate ? t('ONBOARDING_VISOR.SKIP.TEXT_REAL_ESTATE') : t('ONBOARDING_VISOR.SKIP.TEXT') }}
      </p>
      <ul class="grid gap-2.5 my-5 p-4 rounded-xl bg-n-slate-3">
        <li v-for="item in losses" :key="item" class="flex gap-2.5 items-center text-sm text-n-slate-11">
          <Icon icon="i-ph-x-circle-duotone" class="size-[1.125rem] text-n-amber-11 flex-none" />
          {{ t(`ONBOARDING_VISOR.SKIP.LOSSES.${item}`) }}
        </li>
      </ul>
      <label class="flex gap-2.5 items-center text-sm text-n-slate-11 cursor-pointer">
        <input v-model="understood" type="checkbox" class="size-5 rounded-md !m-0" data-testid="entendi" />
        {{ t('ONBOARDING_VISOR.SKIP.UNDERSTOOD') }}
      </label>
      <div class="grid gap-2.5 mt-[1.375rem]">
        <button type="button" :class="BTN" data-testid="conectar-agora" @click="emit('connect')">
          <Icon icon="i-ri-whatsapp-fill" class="size-5" />
          {{ t('ONBOARDING_VISOR.SKIP.CONNECT_NOW') }}
        </button>
        <button type="button" :class="BTN_SECONDARY" :disabled="!understood" data-testid="pular-mesmo" @click="emit('skip')">
          {{ t('ONBOARDING_VISOR.SKIP.SKIP_ANYWAY') }}
        </button>
      </div>
      <p class="flex items-center gap-2 mt-3" :class="SMALL">
        <Icon icon="i-ph-shield-check-duotone" class="size-4 text-n-teal-11" />
        {{ t('ONBOARDING_VISOR.SKIP.LATER') }}
      </p>
    </div>
  </div>
</template>
